const THUMBNAILS_POSITION = {
    ON_GALLERY: 'ON_GALLERY',
    OUTSIDE_GALLERY: 'OUTSIDE_GALLERY',
};
export default THUMBNAILS_POSITION;
//# sourceMappingURL=layoutParams_thumbnails_position.js.map